(function () {
  var sections = document.querySelectorAll('[id^="SectionRuEstudosHomeV2-"]');
  if (!sections.length) return; 

  sections.forEach(function (section) {
    if (section.dataset.ruEstudosHomeV2Initialized === 'true') return;
    section.dataset.ruEstudosHomeV2Initialized = 'true';  

    var track = section.querySelector('[data-studies-track]');
    var cards = section.querySelectorAll('.section-ru-estudos-home-v2__card');
    var prev = section.querySelector('[data-studies-prev]');
    var next = section.querySelector('[data-studies-next]');  
    var index = 0;

    if (!track || cards.length < 2) return; 

    function visibleCards() {
      return window.innerWidth < 768 ? 1 : 3;
    }

    function maxIndex() {
      return Math.max(0, cards.length - visibleCards());
    }

    function cardWidth() {
      var card = cards[0];
      if (!card) return 0;
      return card.getBoundingClientRect().width + 20;
    }

    function update() {
      if (window.innerWidth < 768) {
        track.style.transform = '';
        return;
      }

      if (index > maxIndex()) index = maxIndex();
      if (index < 0) index = 0;
      track.style.transform = 'translateX(-' + index * cardWidth() + 'px)';
    }

    if (next) {
      next.addEventListener('click', function () {
        if (window.innerWidth < 768) {
          track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
          return;
        }
        if (index < maxIndex()) index += 1;
        update();
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        if (window.innerWidth < 768) {
          track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
          return;
        }
        if (index > 0) index -= 1;
        update();
      });
    }

    window.addEventListener('resize', update);
    update();
  });
})();
